export const getSessionStatusBadgeVariant = (status: "ok" | "error") => {
  if (status === "error") {
    return { danger: true };
  }
  return {};
};
